let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aR95z")).then(() => parcelRequire('3waQV'));